import { MediaMatcher } from '@angular/cdk/layout';
import {ChangeDetectorRef, Component,OnDestroy,AfterViewInit, ViewChild, OnInit, ElementRef} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { AssistanceFormAdapterImplementationService } from 'src/app/services/assistance-form-adapter-implementation.service';
import { NgxAssistanceFormComponent, NgxAssistanceFormUser } from '@mare-common/ngx-assistance-form';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { UserCompanyService } from 'src/app/services/userCompany.service';


export class NgxAssistanceFormUserExtended extends NgxAssistanceFormUser {
  businessName?: string;
}

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})
export class FullComponent implements OnInit, OnDestroy {

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  toolbarCondensed: boolean = false;
  logoPath!: string ;
  logoDarkPath!: string;
  lightMode: boolean = true;

  @ViewChild(MatSidenavContainer) sidenavContainer!: MatSidenavContainer;

  @ViewChild('toolbar') toolbar!: ElementRef;

  // scrollerSubscription!: Subscription;
  changeDetector: any;

  person: NgxAssistanceFormUserExtended = {
    email: 'notLogged@yopmail.com',
    name: 'Not',
    surname: 'Logged',
    userId: '0'
  };

  // LOCAL
  // staticToken = 'B2B_e5bc1544-6b77-4ed9-92dd-dd1e779c948e';
  // PROD
  staticToken = 'B2B_3c1a8882-6cf7-4052-8852-80abd5b2ebcb';
  recaptchaSiteKey = '6LduNgIgAAAAAHof_ne8DYBSuBeQyeFOoAqZsO3L';
  isOverflowing: boolean = false;
  sidenavOpen: boolean = false;

  @ViewChild('assistanceForm') assistanceForm!: NgxAssistanceFormComponent;
  eventInteractionServiceSub!: Subscription;

  layoutABtest!: 'a' | 'b';
  currentContainerMediaSize: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'xs';
  userCompanySub!: Subscription;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    public menuItems: MenuItems,
    public commonConfig: CommonConfig,
    public assistanceFormAdapterImplementationService: AssistanceFormAdapterImplementationService,
    public eventInteractionService: EventInteractionService,
    public userCompanyService: UserCompanyService,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: ' + commonConfig.getMobileBreakpoint() + 'px)');
    
    // console.log(this.currentContainerMediaSize , this.mobileQuery.matches)
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('resize', this._mobileQueryListener);
    this.changeDetector = changeDetectorRef;
    this.logoPath = this.commonConfig.getSiteLogo();
    this.logoDarkPath =  this.commonConfig.getSiteLogoDarkMode();
  }
  ngOnInit(): void {
   this.layoutABtest = this.commonConfig.getDashboardLayout() as 'a' | 'b';
    // TODO effettuare la verifica dell'utente da window o da service...
    this.eventInteractionServiceSub = this.eventInteractionService.getObservable().subscribe((data: EventData) => {
      // console.log('eventInteractionService', data);
      switch (data.event) {
        case 'openAssistanceFormPlatform':
          let tags = ['platform', 'report request', ];
          if(data.data?.piva)
            tags.push("piva:" + data.data.piva);
          if(data.data?.prezzo)
            tags.push("valore: "+data.data.prezzo);
          this.assistanceForm?.__openForm({
            forceOpenForm: false,
            tryUseSolveup: true,
            tryUseQuestionnaire: false,
            askUserToSolveup: true, // flag che se true mostra l'intro dell'assistance form
            tryUseSolveupConfig: {
              tags: tags
            },
            webSolveupConfig: {
              handleOnSuccessMessage:  "Richiesta di assistenza inviata",
              unloadMessage:  "Sei sicuro di voler chiudere la pagina?",
              closedEmergencyMessageByOperator:  "L'operatore ha terminato la sessione",
              defaultWaitMessage:  "Attendere prego...",
              noUserAvailable:  "Non ci sono utenti disponibili",
              noOperatorsAvailable:  "Non ci sono operatori disponibili",
              genericErrorMessage:  "Errore durante la richiesta di assistenza",
              operatorStartsCallMessage:  "Un operatore è entrato in call...",
              closedEmergencyMessageByUser:  "Hai terminato la sessione",
              linkfyEnabled: true,
              enableAudio: true,
              enableVideo: true,
              tryStartChat: true
            }
          })
          // this.assistanceForm?.openForm(false, true, false, undefined, undefined, true);
          break;
          case 'setVideocallFullscreen':
            if(data.data != undefined && data.data != null && this.assistanceForm?.webSolveupComponent) {
              this.assistanceForm?.webSolveupComponent.setVideoFullscreen(data.data);
            }
            break;
          case 'closeAssistanceForm':
            if(this.assistanceForm.webSolveupComponent.emergencyId) {
              this.assistanceForm.webSolveupComponent.emergencyService.closeEmergency();
              this.eventInteractionService.publishData({event: 'closeemergency'})
            }
            break;
      }
    })

    this.userCompanySub = this.userCompanyService.userCompany$.subscribe((res: {user: any, company: any}) => {
      // console.log('user and company', res)
      this.person.email = res.user?.email ?? '';
      this.person.name = res.user?.name ?? '';
      this.person.surname = res.user?.surname ?? '';
      this.person.userId = res.user?.userId ?? '';
      this.person.phone = res.user?.phonePrefix + (res.user?.phone ?? '');

      if(res.company){
        this.person.vatNumber = res.company.piva;
        this.person.businessName = res.company.business_name;
      }

      // console.log('person', this.person);
    })

    this.staticToken = this.commonConfig.getFromConfig('solveupStaticToken', 'B2B_3c1a8882-6cf7-4052-8852-80abd5b2ebcb');
    this.recaptchaSiteKey = this.commonConfig.getFromConfig('recaptchaSiteKey', '6LduNgIgAAAAAHof_ne8DYBSuBeQyeFOoAqZsO3L');
  }

  // onComponentLoad($event: any) {
  //   console.log('onComponentLoad', $event);
  //   }


  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('resize', this._mobileQueryListener);
    // this.scrollerSubscription.unsubscribe();
    if(this.eventInteractionServiceSub)
      this.eventInteractionServiceSub.unsubscribe();

    if(this.userCompanySub)
      this.userCompanySub.unsubscribe();
  }
  // ngAfterViewInit() {
  //   console.debug('afertViewInit');

  //   // if (this.sidenavContainer) {
  //   // this.scrollerSubscription = this.sidenavContainer.scrollable.elementScrolled().subscribe((event) => {
  //   //   if (this.sidenavContainer.scrollable.measureScrollOffset('top') > 52 ) {
        
  //   //     if (!this.toolbarCondensed) {
  //   //       this.toolbarCondensed = true;
  //   //       this.changeDetector.detectChanges();
  //   //     }
  //   //   } else  {
  //   //     if (this.toolbarCondensed) {
  //   //          this.toolbarCondensed = false;
  //   //       this.changeDetector.detectChanges();
  //   //     }
  //   //   }
  //   // } /* react to scrolling */);
  //   // }
  // }

  togglesidenav() {
      this.sidenavOpen = !this.sidenavOpen;
  }
 
}
